import { Link } from "react-router-dom";
import { ListChecks, LogOut, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { LoginPrompt } from "@/components/common/States";
import { PageHeader } from "@/components/common/Layout";
import { initials } from "@/lib/format";

export default function ProfilePage() {
  const { user, isAdmin, isAuthed, loading, logout } = useAuth();
  if (loading) return null;
  if (!isAuthed) return <div className="lm-container py-12"><LoginPrompt /></div>;
  return (
    <div className="lm-container max-w-3xl pb-20">
      <PageHeader eyebrow="Mon compte" title="Profil" />
      <div className="lm-card p-8" data-testid="profile-card">
        <div className="flex items-center gap-5">
          <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-primary font-heading text-xl font-bold text-white">{initials(user.name)}</span>
          <div>
            <h2 className="text-2xl font-extrabold" data-testid="profile-name">{user.name}</h2>
            <p className="text-stone-600" data-testid="profile-email">{user.email}</p>
            <span className="mt-2 inline-flex items-center gap-1 rounded-full bg-accent px-2.5 py-0.5 text-xs font-bold text-primary" data-testid="profile-role">
              {isAdmin && <ShieldCheck className="h-3 w-3" />} {isAdmin ? "Administrateur" : "Utilisateur"}
            </span>
          </div>
        </div>
        <p className="mt-6 rounded-xl bg-stone-50 p-4 text-sm text-stone-600">
          Votre nom et votre rôle sont gérés par les administrateurs dans la base Notion « Utilisateurs de l'annuaire ».
        </p>
        <div className="mt-6 flex flex-wrap gap-3">
          <Button asChild variant="outline" className="rounded-full"><Link to="/listes?mine=1"><ListChecks className="h-4 w-4" /> Mes listes</Link></Button>
          {isAdmin && <Button asChild variant="outline" className="rounded-full"><Link to="/admin"><ShieldCheck className="h-4 w-4" /> Administration</Link></Button>}
          <Button variant="ghost" className="rounded-full text-red-600 hover:bg-red-50 hover:text-red-700" onClick={logout} data-testid="profile-logout-button"><LogOut className="h-4 w-4" /> Se déconnecter</Button>
        </div>
      </div>
    </div>
  );
}
